<script lang="ts">
  import { messages } from './messages';
  import type { TranslationKey } from './types';
  import { getMessage, getParts } from './utils';

  export let key: TranslationKey;

  $: message = getMessage($messages, key);
  $: parts = getParts(message);
</script>

{#each parts as { type, value }}
  {#if type === 'match'}
    <slot match={value}>{value}</slot>
  {:else}
    {value}
  {/if}
{/each}
